// Video API service

export async function getVideoList({ phone, page = 1, pageSize = 12 } = {}) {
  const params = new URLSearchParams();
  if (phone) params.set('phone', phone);
  if (page) params.set('page', String(page));
  if (pageSize) params.set('pageSize', String(pageSize));

  const resp = await fetch(`/api/video-list?${params.toString()}` , {
    method: 'GET',
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(text || `Failed to fetch video list (${resp.status})`);
  }

  return resp.json();
}

export async function generateVideo({ fileKey, audioUrl }) {
  const resp = await fetch('/api/video/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ fileKey, audioUrl }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const msg = data?.message || 'Failed to start video generation';
    throw new Error(msg);
  }
  return data; // { success, taskId }
}

export async function checkVideoTask(taskId) {
  const resp = await fetch(`/api/video/task/${encodeURIComponent(taskId)}`, {
    method: 'GET',
    credentials: 'include',
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const msg = data?.message || 'Failed to check task status';
    throw new Error(msg);
  }
  return data; // { success, status, statusText, mediaUrl }
}

export async function getBaseVideoList({ phone, page = 1, pageSize = 12, search = '', groupId = '' } = {}) {
  const params = new URLSearchParams();
  if (phone) params.set('phone', phone);
  if (page) params.set('page', String(page));
  if (pageSize) params.set('pageSize', String(pageSize));
  if (search) params.set('search', search);
  if (groupId) params.set('groupId', groupId);

  const resp = await fetch(`/api/video/base_vid/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(text || `Failed to fetch base video list (${resp.status})`);
  }

  return resp.json();
}

export async function getImageList({ page = 1, pageSize = 12, search = '', groupId = '' } = {}) {
  const params = new URLSearchParams();
  if (page) params.set('page', String(page));
  if (pageSize) params.set('pageSize', String(pageSize));
  if (search) params.set('search', search);
  if (groupId) params.set('groupId', groupId);

  const resp = await fetch(`/api/video/base_vid/img/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(text || `Failed to fetch image list (${resp.status})`);
  }

  return resp.json();
}

